/**
 * Forum routes.
 */
export const forumRoutes = [
  {
    path: "/forum",
    name: "forumCategories",
    component: () => import(/* webpackChunkName: "forumCategories" */ "@/views/Forum/ForumCategories.vue"),
    meta: {
      role: "none",
      forum: true,
      banner: { image: "forum", height: "short" },
      title: { title: "banner_title_forum_categories", titleTranslated: false, subtitle: "" },
    },
  },
  {
    path: "/forum/category/:categoryId",
    name: "forumCategory",
    component: () => import(/* webpackChunkName: "forumCategory" */ "@/views/Forum/ForumCategory.vue"),
    meta: {
      role: "none",
      forum: true,
      banner: { image: "forum", height: "short" },
      breadcrumbs: [
        { target: { name: "forumCategories" }, text: "breadcrumb_forum" },
        { target: { name: "forumCategory" }, text: "ellipsis" },
      ],
      title: { title: "banner_title_forum_category", titleTranslated: false, subtitle: "" },
    },
  },
  {
    path: "/forum/post/:categoryId/:postId",
    name: "forumPost",
    component: () => import(/* webpackChunkName: "forumPost" */ "@/views/Forum/ForumPost.vue"),
    meta: {
      role: "none",
      forum: true,
      banner: { image: "forum", height: "short" },
      breadcrumbs: [
        { target: { name: "forumCategories" }, text: "breadcrumb_forum" },
        { target: { name: "forumCategory", params: { categoryId: 0 } }, text: "ellipsis" },
        { target: { name: "forumPost" }, text: "ellipsis" },
      ],
      title: { title: "banner_title_forum_post", titleTranslated: false, subtitle: "" },
    },
  },
  {
    path: "/forum/post-add/:categoryId",
    name: "forumPostAdd",
    component: () => import(/* webpackChunkName: "forumPost" */ "@/views/Forum/PostAdd.vue"),
    meta: {
      role: "none",
      forum: true,
      banner: { image: "forum", height: "short" },
      breadcrumbs: [
        { target: { name: "forumCategories" }, text: "breadcrumb_forum" },
        { target: { name: "forumCategory", params: { categoryId: 0 } }, text: "ellipsis" },
        { target: { name: "forumPost" }, text: "breadcrumb_forum_post_add" },
      ],
      title: { title: "banner_title_forum_post_add", titleTranslated: false, subtitle: "" },
    },
  },
  {
    path: "/forum/category-add",
    name: "forumCategoryAdd",
    component: () => import(/* webpackChunkName: "forumCategoryAdd" */ "@/views/Forum/CategoryAdd.vue"),
    meta: {
      role: "admin",
      forum: true,
      banner: { image: "forum", height: "short" },
      breadcrumbs: [
        { target: { name: "forumCategories" }, text: "breadcrumb_forum" },
        { target: { name: "forumCategoryAdd" }, text: "breadcrumb_forum_category_add" },
      ],
      title: { title: "banner_title_forum_category_add", titleTranslated: false, subtitle: "" },
    },
  },
  {
    path: "/forum/category-edit/:categoryId",
    name: "forumCategoryEdit",
    component: () => import(/* webpackChunkName: "forumCategoryEdit" */ "@/views/Forum/CategoryEdit.vue"),
    meta: {
      role: "admin",
      forum: true,
      banner: { image: "forum", height: "short" },
      breadcrumbs: [
        { target: { name: "forumCategories" }, text: "breadcrumb_forum" },
        { target: { name: "forumCategoryEdit" }, text: "breadcrumb_forum_category_edit" },
      ],
      title: { title: "banner_title_forum_category_edit", titleTranslated: false, subtitle: "" },
    },
  },
];
